module.exports = __webpack_public_path__ + "img/close.c744e28.svg";